<template>
  <div class="promo">
    <PromoPageHeader @showPopup="showPopup" @moveToFirstSlide="moveToFirstSlide" />

    <section>
      <PromoPageIntro @showPopup="showPopup" />
    </section>

    <ProjectRegisterMyGames
      v-if="isShowProjectRegister"
      @closeProjectRegister="closeProjectRegister"
    />
  </div>
</template>

<script>
import "@assets/promo/styles/promo.styl";
import Cookie from "js-cookie";
import ThrowGTMEvent from "@model/helpers/ThrowGTMEvent";

import PromoPageHeader from "./blocks/PromoPageHeader";
import PromoPageIntro from "./blocks/PromoPageIntro";

import ProjectRegisterMixin from "@libs/authorization/ProjectRegisterMixin";
import WindowSizeMixin from "@/components/Common/WindowSizeMixin";
import { mapGetters } from "vuex";

export default {
  name: "PromoPage",
  components: {
    PromoPageHeader,
    PromoPageIntro,
  },

  mixins: [ProjectRegisterMixin, WindowSizeMixin],

  computed: {
    ...mapGetters("global", ["isClient", "getUserData"]),
  },

  mounted() {
    ThrowGTMEvent("ch.page", { screen_id: 1 });
    this.generateUserGTMEvent();
  },

  methods: {
    showPopup() {
      if (this.isUserInProject) {
        this.$store.dispatch("global/startEvent");
      } else if (this.isUserNotAuthed) {
        this.signIn();
      } else if (this.isUserAuthedNotRegistered) {
        this.signUp();
      }
    },

    generateUserGTMEvent() {
      if (this.isUserInProject) {
        const event = Cookie.get("new_user") ? "ch.registration.finish" : "ch.visit";

        ThrowGTMEvent(event, { userID: this.getUserData.csaid });
        Cookie.remove("new_user");
      }
    },
  },
};
</script>
